export type DropdownSearchEvent = {
    event: 'dropdown_search';
    search_term: string;
    clicked_item: {
        item_name: string;
        index: string;
    }[];
    search_hits: string;
};

export const trackDropdownSearchEvent = (
    query: string,
    productName: string,
    index: string,
    hits: string
): DropdownSearchEvent => ({
    event: 'dropdown_search',
    search_term: query,
    clicked_item: [
        {
            item_name: productName,
            index: index
        }
    ],
    search_hits: hits
});
